export const LEGAL_TERMS_URL = "https://cliently.fr/legal/terms";
export const LEGAL_PRIVACY_URL = "https://cliently.fr/legal/privacy";
